import { SearchState } from '../../../models';
import { SEARCH_MUTATIONS_KEYS } from '../search.const';
import { SearchMutation } from '../search.interfaces';

export class SetKeepPreviousResults implements SearchMutation {

  mutations = {
    [SEARCH_MUTATIONS_KEYS.setKeepPreviousResults]: (searchState: SearchState, keep: boolean) => {
      searchState.keepPreviousResults = keep;
    }
  };
}
